import { useMemo, useRef } from 'react';

export const useTabAwareMemo = <T>(
  activeTab: string,
  owningTabs: readonly string[],
  compute: () => T,
  deps: readonly unknown[]
): T => {
  const cacheRef = useRef<T | undefined>(undefined);
  const shouldCompute = owningTabs.includes(activeTab);

  return useMemo(() => {
    if (shouldCompute) {
      const next = compute();
      cacheRef.current = next;
      return next;
    }

    if (cacheRef.current !== undefined) {
      return cacheRef.current;
    }

    const initial = compute();
    cacheRef.current = initial;
    return initial;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, shouldCompute, ...deps]);
};
